import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY')
}

/** Legacy pg2 client — used by existing blocks/flows. Will be phased out. */
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  db: { schema: 'pg2' },
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
})

/** Commerce-native client — targets the new commerce schema (Phase 5000+). */
export const commerceDb = createClient(supabaseUrl, supabaseAnonKey, {
  db: { schema: 'commerce' },
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
})
